import { render } from "./ClientEmployee.vue?vue&type=template&id=185d5554"
import script from "./ClientEmployee.vue?vue&type=script&lang=js"
export * from "./ClientEmployee.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__